import MenuItem from "./MenuItem";
import Submenu from "./Submenu";

export default function SidebarMenu() {
  return (
    <>
      <ul>
        <li className="menu-title">
          <span>Main Menu</span>
        </li>

        {/* Dashboard */}
        <Submenu
          icon="ti ti-layout-dashboard"
          title="Dashboard"
          defaultOpen={true}
          active={true}
          items={[
            { label: "Admin Dashboard", link: "index.html", active: true },
            { label: "Doctor Dashboard", link: "doctor-dashboard.html" },
            { label: "Patient Dashboard", link: "patient-dashboard.html" },
          ]}
        />

        {/* Applications */}
        <Submenu
          icon="ti ti-apps"
          title="Applications"
          items={[
            { label: "Chat", link: "chat.html" },
            {
              label: "Calls",
              submenu: [
                { label: "Voice Call", link: "voice-call.html" },
                { label: "Video Call", link: "video-call.html" },
                { label: "Outgoing Call", link: "outgoing-call.html" },
                { label: "Incoming Call", link: "incoming-call.html" },
                { label: "Call History", link: "call-history.html" },
              ],
            },
            { label: "Calendar", link: "calendar.html" },
            { label: "Contacts", link: "contacts.html" },
          ]}
        />
      </ul>
    </>
  );
}
